var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container bg-loader"},[_c('div',{staticClass:"row loader"},[_c('div',{staticClass:"col-12 my-lg-5"},[_c('div',{staticClass:"centered"},[_c('h1',{staticClass:"logo"},[_vm._v("BANTABA")]),_c('NewLoader')],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }